<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveTranslation()" autocomplete="off">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="language_id">Idioma <span class="text-danger">*</span></label>
                <select
                  id="language_id"
                  v-model="translationData.language_id"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.translationData.language_id.$error
                  }"
                  :disabled="isEditing"
                >
                  <option value="">Selecione um idioma</option>
                  <option v-for="lang in languages" :key="lang.id" :value="lang.id">
                    {{ lang.flag }} {{ lang.name }}
                  </option>
                </select>
                <div
                  v-if="submitted && !$v.translationData.language_id.required"
                  class="invalid-feedback"
                >
                  Selecione um idioma.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="group">Grupo <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    id="group"
                    v-model="translationData.group"
                    name="group"
                    type="text"
                    class="form-control"
                    placeholder="Ex: general, auth, errors"
                    list="groupList"
                    :class="{
                      'is-invalid': submitted && $v.translationData.group.$error
                    }"
                    :disabled="isEditing"
                  />
                  <datalist id="groupList">
                    <option v-for="g in groups" :key="g" :value="g">{{ g }}</option>
                  </datalist>
                </div>
                <div
                  v-if="submitted && !$v.translationData.group.required"
                  class="invalid-feedback"
                >
                  O campo grupo é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="key">Chave <span class="text-danger">*</span></label>
                <input
                  id="key"
                  v-model="translationData.key"
                  name="key"
                  type="text"
                  class="form-control"
                  placeholder="Ex: welcome_message, button.submit, errors.required"
                  :class="{
                    'is-invalid': submitted && $v.translationData.key.$error
                  }"
                  :disabled="isEditing"
                />
                <small class="text-muted">Use notação de ponto para chaves aninhadas (ex: navbar.menu.home)</small>
                <div
                  v-if="submitted && !$v.translationData.key.required"
                  class="invalid-feedback"
                >
                  O campo chave é obrigatório.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="value">Valor <span class="text-danger">*</span></label>
                <textarea
                  id="value"
                  v-model="translationData.value"
                  name="value"
                  rows="4"
                  class="form-control"
                  placeholder="Digite a tradução..."
                  :class="{
                    'is-invalid': submitted && $v.translationData.value.$error
                  }"
                ></textarea>
                <small class="text-muted">Você pode usar variáveis como :name ou {name} dependendo do sistema</small>
                <div
                  v-if="submitted && !$v.translationData.value.required"
                  class="invalid-feedback"
                >
                  O campo valor é obrigatório.
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveTranslation()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  props: {
    translation: {
      type: Object,
      default: null
    },
    languages: {
      type: Array,
      default: () => []
    },
    groups: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      title: 'Nova Tradução',
      loading: false,
      submitted: false,
      isEditing: false,
      translationData: {
        language_id: '',
        group: '',
        key: '',
        value: ''
      },
      modal: false
    }
  },
  validations () {
    return {
      translationData: {
        language_id: { required },
        group: { required },
        key: { required },
        value: { required }
      }
    }
  },
  methods: {
    ...mapActions('translation', {
      postData: 'save'
    }),
    open (item = null) {
      this.modal = true
      this.loading = false
      this.submitted = false

      if (item && item.id) {
        this.title = 'Editar Tradução'
        this.isEditing = true
        this.translationData = {
          id: item.id,
          language_id: item.language_id,
          group: item.group,
          key: item.key,
          value: item.value
        }
      } else {
        this.title = 'Nova Tradução'
        this.isEditing = false
        this.translationData = {
          language_id: '',
          group: '',
          key: '',
          value: ''
        }
      }
    },
    async saveTranslation () {
      this.submitted = true
      this.$v.translationData.$touch()
      if (this.$v.translationData.$invalid) {
        return
      }
      this.loading = true
      await this.postData(this.translationData).then(() => {
        successMessage('Tradução salva com sucesso.', 2500)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Erro: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.isEditing = false
      this.translationData = {
        language_id: '',
        group: '',
        key: '',
        value: ''
      }
      this.$v.$reset()
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
